import { createSelector } from 'reselect'

const getInboxEmails = ({ inbox }) => {
  return {
    inboxEmails: inbox?.inboxEmails,
    next: inbox?.next,
    previous: inbox?.previous,
  }
}

const fetchingInboxEmails = ({ inbox }) => inbox.fetchingInboxEmails

const getUserEmail = ({ dataSource }) => {
  return dataSource?.sources[0]?.connectedEmail
}

export const inboxEmailsSelectors = {
  getInboxEmails: createSelector([getInboxEmails], ({ next, previous, inboxEmails }) => {
    return { next, previous, inboxEmails }
  }),

  fetchingInboxEmails: createSelector([fetchingInboxEmails], (fetchingInboxEmails) => {
    return fetchingInboxEmails
  }),

  getUserEmail: createSelector([getUserEmail], (userEmail) => {
    return userEmail
  }),
}

export default inboxEmailsSelectors
